<template>
  <div class="team-list">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :model="searchForm" inline>
        <el-form-item label="项目名称">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入项目名称"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 120px">
            <el-option label="正常" :value="1" />
            <el-option label="解散" :value="0" />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 表格 -->
    <el-card class="table-card mt-20">
      <el-table :data="teamList" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="项目名称" />
        <el-table-column prop="projectName" label="工程名称" />
        <el-table-column prop="projectAddress" label="项目地址" />
        <el-table-column label="创建者身份" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.creatorType === 2 ? 'warning' : 'primary'" size="small">
              {{ scope.row.creatorType === 2 ? '包工头' : '工人' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="leaderName" label="创建者" width="120">
          <template slot-scope="scope">
            {{ scope.row.leaderName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="成员数量" width="100">
          <template slot-scope="scope">
            {{ scope.row.memberCount || 0 }}人
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '正常' : '解散' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" @click="handleMembers(scope.row)">成员</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        class="mt-20"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNum"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </el-card>
    
    <!-- 成员弹窗 -->
    <el-dialog title="项目成员" :visible.sync="memberVisible" width="600px">
      <el-table :data="memberList" border stripe>
        <el-table-column label="成员名称">
          <template slot-scope="scope">
            {{ scope.row.displayName || scope.row.memberName || scope.row.nickname || '未知' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号">
          <template slot-scope="scope">
            {{ scope.row.phone || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="角色" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.role === 2 ? 'warning' : 'primary'">
              {{ scope.row.role === 2 ? '项目负责人' : '工人' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TeamList',
  data() {
    return {
      searchForm: {
        name: '',
        status: null
      },
      teamList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      memberVisible: false,
      memberList: []
    }
  },
  created() {
    this.loadTeamList()
  },
  methods: {
    async loadTeamList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm
        }
        const res = await this.$http.get('/admin/team/list', { params })
        this.teamList = res.records || []
        this.total = res.total || 0
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.pageNum = 1
      this.loadTeamList()
    },
    
    handleReset() {
      this.searchForm = {
        name: '',
        status: null
      }
      this.handleSearch()
    },
    
    handlePageChange(page) {
      this.pageNum = page
      this.loadTeamList()
    },
    
    handleSizeChange(size) {
      this.pageSize = size
      this.handleSearch()
    },
    
    handleView(row) {
      const creatorTypeText = row.creatorType === 2 ? '包工头' : '工人'
      this.$alert(`
        <p>项目名称：${row.name}</p>
        <p>工程名称：${row.projectName || '未设置'}</p>
        <p>项目地址：${row.projectAddress || '未设置'}</p>
        <p>创建者身份：${creatorTypeText}</p>
        <p>创建者：${row.leaderName || '未知'}</p>
        <p>描述：${row.description || '无'}</p>
      `, '项目详情', {
        dangerouslyUseHTMLString: true
      }).catch(() => {})
    },
    
    async handleMembers(row) {
      try {
        const res = await this.$http.get(`/admin/team/members/${row.id}`)
        this.memberList = res || []
        this.memberVisible = true
      } catch (error) {
        console.error(error)
      }
    },
    
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped lang="scss">
.team-list {
  .search-card {
    ::v-deep .el-card__body {
      padding-bottom: 0;
    }
  }
}
</style>
